import React, { useEffect, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import { API } from "aws-amplify";
import { processPolls } from "../../libs/processPolls";
import {
  Row,
  Col
} from "react-bootstrap";
import { Helmet } from 'react-helmet';
import "./Community.css";
import PollCard from "../../components/PollCard";
import QuestionCard from "../../components/QuestionCard";
import Loader from "../../components/Loader";
import { processQuestions } from "../../libs/processQuestions";
import { processAnswers } from "../../libs/processAnswers";
import CommunityBanner from "../../components/CommunityBanner";
import RHS from "../../components/RHS";

export default function Communities(props) {
  const [community, setCommunity] = useState(null);

  const [polls, setPolls] = useState(null);
  const [hasMorePolls, setHasMorePolls] = useState(null);
  const [keyPolls, setKeyPolls] = useState(null);

  const [questions, setQuestions] = useState(null);
  const [hasMoreQuestions, setHasMoreQuestions] = useState(null);
  const [keyQuestions, setKeyQuestions] = useState(null);

  const [articles, setArticles] = useState(null);
  const [hasMoreArticles, setHasMoreArticles] = useState(null);
  const [keyArticles, setKeyArticles] = useState(null);

  useEffect(() => {
    props.setIsMember(false);

    const path = 'communities/' + props.match.params.comm_id;
    API.get('comms', path).then(resp => {
      props.setCommunity(resp);
      setCommunity(resp);
      if (props.user.communities && props.user.communities.includes(resp.comm_id))
        props.setIsMember(true);

      // fetch polls   
      let params = {queryStringParameters: {limit: 8, keyword: resp.keyword }};
      API.get('polls', 'polls', params).then(async resp => {
        const processedPolls = await processPolls(resp.Items, props.pollResponses);
        setPolls(processedPolls);
        if ("LastEvaluatedKey" in resp) {
          setKeyPolls(resp.LastEvaluatedKey);
          setHasMorePolls(true);
        } else {
          setHasMorePolls(false);
        }
      });

      // fetch questions
      params = {queryStringParameters: {limit: 8, keyword: resp.keyword }};
      API.get('questions', 'questions', params).then(async resp => {
        const processedQuestions = await processQuestions(resp.Items);
        if ("LastEvaluatedKey" in resp) {
          setKeyQuestions(resp.LastEvaluatedKey);
          setHasMoreQuestions(true);
        } else {
          setHasMoreQuestions(false);
        }
        const answers = await Promise.all(processedQuestions.map(async ques => {
          // get (and process) answers
          const path = 'answers/' + ques.question_id;
          const answer = API.get('questions', path).then(async resp => {
            let answers = await processAnswers(resp, {}, props.user.UID);
            answers = answers.filter(cmnt => !cmnt.deleted);
            answers.sort(function (a, b) {return parseInt(b.ups) - parseInt(a.ups);});
            return answers[0];
          });
          return answer;
        }));
        processedQuestions.forEach((ques, idx) => {
          processedQuestions[idx].preview = answers[idx];
        });
        setQuestions(processedQuestions);
      });
  
        
      // fetch articles
      params = {queryStringParameters: {limit: 8, keyword: resp.keyword }};
      API.get('articles', 'articles', params).then(resp => {
        setArticles(resp.Items);
        if ("LastEvaluatedKey" in resp) {
          setKeyArticles(resp.LastEvaluatedKey);
          setHasMoreArticles(true);
        } else {
          setHasMoreArticles(false);
        }
      });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.url])

  function fetchMore() {
    // prevent spamming
    if (!hasMorePolls && !hasMoreArticles && !hasMoreQuestions) return;

    let morePolls = hasMorePolls;
    let moreQuestions = hasMoreQuestions;
    let moreArticles = hasMoreArticles;
    setHasMorePolls(false);
    setHasMoreQuestions(false);
    setHasMoreArticles(false);

    if (morePolls) {
      const params = { 
        queryStringParameters: {
          ...keyPolls,
          limit: 3,
          keyword: community.keyword
        }
      };
      API.get('polls', 'polls', params).then(async resp => {
        const processedPolls = await processPolls(resp.Items, props.pollResponses);
        setPolls([...polls, ...processedPolls]);
        if ("LastEvaluatedKey" in resp) {
          setKeyPolls(resp.LastEvaluatedKey);
          setHasMorePolls(true);
        } else {
          setHasMorePolls(false);
        }
      });
    }

    if (moreQuestions) {
      const params = { 
        queryStringParameters: {
          ...keyQuestions,
          limit: 3,
          keyword: community.keyword
        }
      };
      API.get('questions', 'questions', params).then(async resp => {
        const processedQuestions = await processQuestions(resp.Items);
        if ("LastEvaluatedKey" in resp) {
          setKeyQuestions(resp.LastEvaluatedKey);
          setHasMoreQuestions(true);
        } else {
          setHasMoreQuestions(false);
        }
        const answers = await Promise.all(processedQuestions.map(async ques => {
          // get (and process) answers
          const path = 'answers/' + ques.question_id;
          const answer = API.get('questions', path).then(async resp => {
            let answers = await processAnswers(resp, {}, props.user.UID);
            answers = answers.filter(cmnt => !cmnt.deleted);
            answers.sort(function (a, b) {return parseInt(b.ups) - parseInt(a.ups);});
            return answers[0];
          });
          return answer;
        }));
        processedQuestions.forEach((ques, idx) => {
          processedQuestions[idx].preview = answers[idx];
        });
        setQuestions([...questions, ...processedQuestions]);
      });
    }

    if (moreArticles) {
      const params = { 
        queryStringParameters: {
          ...keyArticles,
          limit: 3,
          keyword: community.keyword
        }
      };
      API.get('articles', 'articles', params).then(resp => {
        setArticles([...articles, ...resp.Items]);
        if ("LastEvaluatedKey" in resp) {
          setKeyArticles(resp.LastEvaluatedKey);
          setHasMoreArticles(true);
        } else {
          setHasMoreArticles(false);
        }
      });
    }
  }

  const pollsRender = polls ?
    polls.map((poll) => (
      <Col style={{marginBottom: '-20px'}} key={poll.poll_id} xs={12}>
        <PollCard props={props} poll={poll}/>
      </Col>
    )
  ) : [];

  const questionsRender = questions ?
    questions.map((question) => (
      <Col style={{marginBottom: '-10px'}} key={question.question_id} xs={12}>
        <QuestionCard props={props} question={question}/>
      </Col>
    )
  ) : [];

  // interlace (*polls* and questions) and articles
  let feed = [];
  let l = Math.min(pollsRender.length, questionsRender.length);
  for (let i = 0; i < l; i++) {
    feed.push(pollsRender[i], questionsRender[i]);
  }
  feed.push(...pollsRender.slice(l), ...questionsRender.slice(l));

  // shove poll builder card at top of feed
  feed.unshift(
    <Col style={{marginBottom: '-20px'}} key="build" xs={12}>
      <CommunityBanner
        props={props}
        community={props.community}
        setCommunity={props.setCommunity}
        isMember={props.isMember}
        setIsMember={props.setIsMember}
        updatingMembership={props.updatingMembership}
        setUpdatingMembership={props.setUpdatingMembership}
        myCommunities={props.myCommunities}
        setMyCommunities={props.setMyCommunities}
      />
    </Col>
  );

  return community !== null && polls !== null && 
         articles !== null ? (
    <div>
      <Helmet>
        <title>{props.community.comm_name} | icitizen</title>
        <meta name="title" content={`${props.community.comm_name} | icitizen`}/>
        <meta name="description" content={props.community.desc}/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={window.location.href}/>
        <meta property="og:title" content={`${props.community.comm_name} | icitizen`}/>
        <meta property="og:description" content={props.community.desc}/>
        <meta property="og:image" content="https://icitizen.com/ic_card.png"/>
        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content={window.location.href}/>
        <meta property="twitter:title" content={`${props.community.comm_name} | icitizen`}/>
        <meta property="twitter:description" content={props.community.desc}/>
        <meta property="twitter:image" content="https://icitizen.com/ic_card.png"/>
      </Helmet>
      { 
        props.width === 'xl' ? (
          <Row>
            <Col xs={8}>
              <InfiniteScroll
                dataLength={feed.length}
                next={fetchMore}
                hasMore={hasMorePolls || hasMoreArticles}
              >
                <Row>
                  { feed }
                </Row>
              </InfiniteScroll>
            </Col>
            <Col xs={4}>
              <Row>
                { RHS(props) }
              </Row>
            </Col>
          </Row>
        ) : (
          <InfiniteScroll
            dataLength={feed.length}
            next={fetchMore}
            hasMore={hasMorePolls || hasMoreArticles}
          >
            <Row>
              <Col width={12}>
                { [feed.slice(0,2), ...feed.slice(2)] }
              </Col>
            </Row>
          </InfiniteScroll>
        )
      }
    </div>
  ) : <Loader />;
}
